module.exports = __webpack_public_path__ + "static/media/instragramIcon.900b31be.png";